export const MODAL_CONTENT_NOVARTIS = {
  PHARMACOVIGILANCE: `
La pharmacovigilance consiste à surveiller, évaluer et prévenir le risque d'effets indésirables résultant de l'utilisation des médicaments.

<b>Obligation de déclaration</b>

Tout professionnel de santé qui a connaissance d'un effet indésirable susceptible d'être dû à un médicament est tenu de le signaler au Centre Régional de Pharmacovigilance (CRPV).

<b>Comment signaler ?</b>

- Via le portail national : <b>signalement-sante.gouv.fr</b>
- Auprès du laboratoire <b>Novartis</b> : +33 (0)1 55 47 60 00
- Auprès de votre <b>Centre Régional de Pharmacovigilance (CRPV)</b>

<b>Informations à renseigner</b>

- Initiales, date de naissance et sexe du patient
- Description de l'effet indésirable et date de survenue
- Le(s) médicament(s) suspecté(s) avec dose et voie d'administration
- Évolution de l'effet indésirable

La déclaration est <b>obligatoire pour tout effet indésirable grave ou inattendu</b>.

Votre déclaration contribue à améliorer la sécurité des patients.
`,
};
